import React, { useEffect, useMemo } from 'react';
import { useAppSelector, useThunkDispatch } from '@common/hooks';
import ButtonTemplate from '@common/components/button-template';
import { NewFormModal } from '@modules/forms/components/new-form-modal';
import { Overview } from '@common/components/overview';

import * as actions from '../../actions';
import * as formsSelector from '../../selectors';

interface FormTemplatesProps {
  handleCreateForm: (templateId?: string) => void;
  canCreateForms: boolean;
  showUpgradeModal: () => void;
  setTemplatesOpen: (open: boolean) => void;
}

const FormTemplates = ({
  handleCreateForm,
  canCreateForms,
  showUpgradeModal,
  setTemplatesOpen,
}: FormTemplatesProps) => {
  const dispatch = useThunkDispatch();
  const templates = useAppSelector(formsSelector.getTemplates);

  useEffect(() => {
    dispatch(actions.fetchTemplates());
  }, []);

  const templatesList = useMemo(() => {
    return templates?.filter((template) => template.highlighted).slice(0, 5);
  }, [templates]);

  return (
    <Overview>
      <Overview.Content>
        <div className="List SurveyTemplates">
          {canCreateForms ? (
            <NewFormModal
              onOpenTemplates={() => setTemplatesOpen(true)}
              onCreateForm={() => handleCreateForm()}
            >
              <ButtonTemplate title="forms:create_form" />
            </NewFormModal>
            ) : (
              <ButtonTemplate
                title="forms:create_form"
                onTemplateClick={showUpgradeModal}
              />
            )}

          {templatesList?.map((template) => (
            <ButtonTemplate
              key={template.id}
              item={template}
              onTemplateClick={canCreateForms ? handleCreateForm : showUpgradeModal}
            />
          ))}
        </div>
      </Overview.Content>
    </Overview>
  );
};

export default FormTemplates;
